import {
  Typography,
  Dialog as MUIDialog,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
} from "@mui/material";
import { CloseOutlined } from "@mui/icons-material";
import { useSelector } from "react-redux";
import styled from "styled-components";

// Styled Dialog override
const StyledDialog = styled(MUIDialog)`
  .MuiDialog-paper {
    min-width: 95%;
    height: 100%;
  }
`;

// Optional flex div if you need it later
const CenterDiv = styled.div`
  display: flex;
  text-align: center;
  justify-content: center;
`;

export default function ViewAgreement({ viewAgreement, setViewAgreement }) {
  const { siteColors } = useSelector((state) => state.renderUIDetails);

  const handleClose = () => {
    setViewAgreement({
      data: viewAgreement?.data,
      state: false,
    });
  };

  return (
    <StyledDialog open={viewAgreement?.state} onClose={handleClose}>
      <DialogTitle>
        <Grid container spacing={2}>
          <Grid item xs={7}>
            <Typography color={siteColors?.primary} variant="h4">
              View Agreement
            </Typography>
          </Grid>

          <Grid item xs={5} textAlign="end">
            <IconButton onClick={handleClose}>
              <CloseOutlined />
            </IconButton>
          </Grid>
        </Grid>
      </DialogTitle>

      <DialogContent>
        <div className="modal">
          <div className="modalContent">
            <iframe
              title="View Agreement"
              src={`${
                viewAgreement.data.is_verified
                  ? viewAgreement.data?.signed_agreement_link
                  : viewAgreement.data?.unsigned_agreement_link
              }#zoom=100`}
              style={{ width: "100%", height: "550px" }}
              frameBorder="0"
            />
          </div>
        </div>
      </DialogContent>
    </StyledDialog>
  );
}
